/**
 * PremiumAgentPanel
 * 
 * @Author: Focci
 * @Date: 2024-10-25 14:38:25
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-25 14:38:25
 */

'use client'

import AgentAvatar from '@comp/page/agent/AgentAvatar'
import AspectRatioCover from '@comp/AspectRatioCover'
import Link from 'next/link'
import useTracking from '@hook/useTracking'
import { PremiumAgentPhoneButton } from '@comp/page/agent/agents/AgentBrief'
import { useCallback, useMemo, useRef } from 'react'
import { detail } from '@lib/route/agent'
import { useLocale, useTranslations } from 'next-intl'
import { ButtonBase } from '@comp/material'
import PremiumEnquiry from './PremiumEnquiry'

export default function PremiumAgentPanel({ house }) {
  const agent = useMemo(() => house?.agent || {}, [house?.agent])
  
  const { pushTrack } = useTracking()
  const locale = useLocale()
  const th = useTranslations('house')
  const enquiryDialog = useRef()

  const handleEmailClick = useCallback(() => {
    enquiryDialog.current?.openDialog?.()
    pushTrack('click_email', {
      houseId: house.houseId || 0,
      agentId: agent?.id,
      agencyOfficeId: agent.office_id
    })
  }, [pushTrack, house.houseId, agent])
  
  return (
    <div
      style={{ backgroundColor: agent?.bg_color, color: agent?.font_color }}
      className="p-2 flex flex-col gap-4"
    >
      <Link href={detail(agent.slug, locale)} className="flex items-start gap-2">
        <AgentAvatar
          name={agent.name}
          avatar={agent.icon}
          membershipLevel={agent.membership_level}
          width={80}
          height={80}
          wrapperClassName="w-16 shrink-0 rounded-full"
          className="object-cover rounded-full object-top bg-cf0"
        />
        <div className="flex flex-col gap-1 flex-auto">
          <div className="flex items-center justify-between gap-2  mt-1">
            <div className="text-base font-bold line-clamp-1">{agent.name}</div>
            <div className="w-20 ml-auto">
              <AspectRatioCover
                priority
                brand=""
                src={agent.office_icon}
                width={150}
                height={50}
                className="object-contain object-right"
                alt={agent.office_name}
              />
            </div>
          </div>
          <div className="line-clamp-1">{agent.job_title}</div>
        </div>
      </Link>
      <div className="grid grid-cols-2 gap-4">
        <PremiumAgentPhoneButton
          agent={agent}
          className="flex justify-center items-center gap-1 border font-medium rounded-[.2rem] h-8 px-4 cursor-pointer"
          style={{ borderColor: agent?.font_color, color: agent?.font_color }}
        />
        <ButtonBase
          className="rounded-md"
          onClick={handleEmailClick}
        >
          <div className="rounded-sm bg-[#ff5533] text-white w-full px-2 h-8 whitespace-nowrap flex items-center justify-center">
            {th('valuationFree')}
          </div>
        </ButtonBase>
      </div>
      <PremiumEnquiry ref={enquiryDialog} agentId={agent.id} />
    </div>
  )
}
